// Module
var code = "<configuration-electron class=\"electron-config\" ng-if=\"$ctrl.config\" close=\"$ctrl.close()\"></configuration-electron> ";
// Exports
module.exports = code;